module.exports = __webpack_public_path__ + "static/media/customize-lunch.f29ffa0d.png";